/* neu-lab.js — shared index-driven filter engine for collection + search pages.
   Extracted from neu-filter-collection.liquid so search reuses the exact same rail/filters/sort/grid.
   Config comes from #shopGrid data-* attributes (data-scope: catalog|collection|search). */
(function () {
  var root = document.getElementById('shopGrid'); if (!root) return;
  var FALLBACK = root.getAttribute('data-fallback-img');
  var SCOPE = root.getAttribute('data-scope');
  var COLLECTION_URL = root.getAttribute('data-collection-url');
  var grid = document.getElementById('labGrid');
  var filterRoot = document.getElementById('labFilterRoot');
  var countEl = document.getElementById('labCount');
  var emptyEl = document.getElementById('labEmpty');
  var moreBtn = document.getElementById('labMore');
  var sortSel = document.getElementById('labSort');
  var PAGE = 24;
  var ITEMS = [], TAX = null, shown = PAGE, filtered = [];

  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function lc(s) { return String(s).toLowerCase(); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var BADGE_C = { scratch: { bc: 'var(--c-scratch)', bt: '#fff' }, open: { bc: 'var(--c-open)', bt: 'var(--navy)' }, refurb: { bc: 'var(--orange)', bt: '#fff' }, new: { bc: 'var(--c-newbox)', bt: '#fff' } };
  var COND_LABEL = { new: { cond: 'new', label: 'New in Box' }, cr: { cond: 'refurb', label: 'Certified Refurb' }, ob: { cond: 'open', label: 'Open Box' }, sdmin: { cond: 'scratch', label: 'Scratch & Dent · Minor' }, sdmod: { cond: 'scratch', label: 'Scratch & Dent · Moderate' }, sdmaj: { cond: 'scratch', label: 'Scratch & Dent · Major' } };

  // Scope the index to THIS collection. Master/huge collections use the whole index;
  // others fetch their membership (product ids) and intersect — covers ALL products in the collection.
  function catFromHandle(h) {
    // "washers-dryers" = the laundry-family bucket (not one category, not everything). certified-refurbished-
    // washers-dryers should show ONLY washers/dryers/sets, not every refurb category (task 86e2965p3).
    if (h.indexOf('washers-dryers') > -1 || h.indexOf('washers-and-dryers') > -1) return ['WASH', 'DRY', 'WDSET', 'LC', '2IN1'];
    // ORDER MATTERS: specific handles must precede generic substrings they contain.
    // "dishwasher" before "washer" (else "dishwashers" matches 'washer' → WASH — task 86e2a5gah).
    var map = [['washer-dryer', 'WDSET'], ['washer-and-dryer', 'WDSET'], ['wd-set', 'WDSET'], ['laundry-center', 'LC'], ['all-in-one', '2IN1'], ['dishwasher', 'DW'], ['refrigerator', 'REF'], ['fridge', 'REF'], ['freezer', 'FRZ'], ['wall-oven', 'WAL'], ['washer', 'WASH'], ['dryer', 'DRY'], ['range', 'RNG'], ['stove', 'RNG'], ['microwave', 'MCR'], ['cooktop', 'CKT'], ['icemaker', 'ICE'], ['ice-maker', 'ICE'], ['water-heater', 'WHTR'], ['grill', 'GRILL'], ['vent', 'VENT'], ['air-condition', 'AC']];
    for (var i = 0; i < map.length; i++) if (h.indexOf(map[i][0]) > -1) return map[i][1];
    return null;
  }
  async function scopeItems(all) {
    if (SCOPE === 'catalog') return all;
    // Search: scope the in-stock index to products matching the query (all terms must appear in
    // title/brand). Gives the search page the SAME dynamic rail as collections, in-stock only. (Option B)
    if (SCOPE === 'search') {
      var q = (root.getAttribute('data-search-query') || '').toLowerCase().replace(/[^\w\s]+/g, ' ').trim();
      if (!q) return [];
      var terms = q.split(/\s+/).filter(Boolean);
      return all.filter(function (p) {
        var hay = ((p.title || '') + ' ' + (p.vendor || '')).toLowerCase();
        return terms.every(function (t) { return hay.indexOf(t) > -1; });
      });
    }
    // Fast path: condition/category collections scope straight from the index (no products.json fetch).
    // This is what makes huge collections like scratch-dent load instantly instead of paging thousands of members.
    var h = (COLLECTION_URL.split('/').pop() || '').toLowerCase();
    var condFam = /open-?box/.test(h) ? 'open' : /refurb/.test(h) ? 'refurb' : /scratch|dent/.test(h) ? 'scratch' : /new-appliance|new-in-box/.test(h) ? 'new' : null;
    var cat = catFromHandle(h);
    var catSet = cat ? (Array.isArray(cat) ? cat.map(lc) : [lc(cat)]) : null;   // one category, or a family (washers-dryers)
    if (condFam || catSet) {
      var famSet = condFam ? famCodes(condFam) : null;
      return all.filter(function (p) {
        if (catSet && !(p.f.category || []).some(function (c) { return catSet.indexOf(lc(c)) > -1; })) return false;
        if (famSet && !(p.f.condition || []).some(function (c) { return famSet.indexOf(lc(c)) > -1; })) return false;
        return true;
      });
    }
    // Fallback: fetch membership for brand/curated collections that don't map to a condition/category.
    var ids = {}, page = 1, MAXP = 16, any = false;
    while (page <= MAXP) {
      var r;
      try { r = await fetch(COLLECTION_URL + '/products.json?limit=250&page=' + page); } catch (e) { break; }
      if (!r.ok) break;
      var j = await r.json();
      if (!j.products || !j.products.length) break;
      j.products.forEach(function (p) { ids[String(p.id)] = 1; any = true; });
      if (j.products.length < 250) break;
      page++;
    }
    if (!any) return all; // fallback: show full index rather than nothing
    return all.filter(function (it) { return ids[String(it.id)]; });
  }

  Promise.all([
    fetch(root.getAttribute('data-index-url')).then(function (r) { return r.json(); }),
    fetch(root.getAttribute('data-tax-url')).then(function (r) { return r.json(); })
  ]).then(async function (res) {
    TAX = res[1];
    ITEMS = await scopeItems(res[0]);
    var heroN = document.getElementById('labHeroCount'); if (heroN) heroN.textContent = ITEMS.length; // real browsable count
    detectContext();
    buildRail();
    restoreFromUrl();
    updateVisibility();
    apply();
  }).catch(function () { countEl.textContent = 'Could not load products.'; });

  function cardHTML(p, condSel) {
    // Keep the badge consistent with an active condition filter: if the shopper filtered by a condition
    // this product matches, show THAT condition's badge instead of the default priority pick (avoids a
    // "New" filter showing a "Certified Refurb" badge on products tagged with both).
    var cond = p.cond, badge = p.badge;
    if (condSel && condSel.length && p.f.condition) {
      var pcl = p.f.condition.map(lc);
      for (var ci = 0; ci < condSel.length; ci++) { if (pcl.indexOf(condSel[ci]) > -1 && COND_LABEL[condSel[ci]]) { cond = COND_LABEL[condSel[ci]].cond; badge = COND_LABEL[condSel[ci]].label; break; } }
    }
    var bc = BADGE_C[cond] || { bc: 'var(--c-scratch)', bt: '#fff' };
    var img = p.img || FALLBACK;
    var save = p.cap && p.cap > p.price ? ('You save ' + money(p.cap - p.price) + ' (' + Math.round((p.cap - p.price) / p.cap * 100) + '% off)') : '';
    return '<article class="pcard" data-cond="' + esc(cond) + '">' +
      '<div class="pcard__media pcard__media--photo">' +
        (badge ? '<span class="pcard__badge" style="--bc:' + bc.bc + ';--bt:' + bc.bt + '">' + esc(badge) + '</span>' : '') +
        '<a class="pcard__imglink" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' + (p.img2 ? '<img class="pcard__img-alt" src="' + esc(p.img2) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
      '</div>' +
      '<div class="pcard__body">' +
        '<span class="pcard__brand">' + esc(p.vendor) + '</span>' +
        '<h3 class="pcard__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<div class="pcard__rating"><span class="stars" data-stars="5"></span>' + (p.liq ? '' : '<span>Neu Shield 1-yr</span>') + '</div>' +
        '<div class="pcard__price"><b>' + money(p.price) + '</b>' + (p.cap && p.cap > p.price ? '<s>' + money(p.cap) + '</s>' : '') + '</div>' +
        (save ? '<span class="pcard__save">' + save + '</span>' : '') +
        '<div class="pcard__actions"><a class="btn btn--navy pcard__shop" href="' + esc(p.url) + '">Shop Now</a></div>' +
      '</div></article>';
  }

  function selected(grp) { return [].slice.call(filterRoot.querySelectorAll('input[data-fgroup="' + grp + '"]:checked')).map(function (i) { return i.value; }); }
  function countFor(dim, code) { var n = 0, x = lc(code); for (var i = 0; i < ITEMS.length; i++) { var v = ITEMS[i].f[dim]; if (v) { for (var j = 0; j < v.length; j++) { if (lc(v[j]) === x) { n++; break; } } } } return n; }
  function vendorCounts() { var m = {}; ITEMS.forEach(function (p) { if (p.vendor) m[p.vendor] = (m[p.vendor] || 0) + 1; }); return m; }
  function opt(grp, value, label, count) { return '<label class="neu-filters__opt"><input type="checkbox" data-fgroup="' + esc(grp) + '" value="' + esc(value) + '"><span class="neu-filters__opt-label">' + esc(label) + '</span><span class="neu-filters__opt-count">' + (count || 0) + '</span></label>'; }
  function group(title, rows, isOpen, attrs) { if (!rows) return ''; return '<details class="neu-filters__group"' + (isOpen ? ' open' : '') + (attrs || '') + '><summary class="neu-filters__group-title">' + esc(title) + '<span class="neu-filters__plus"></span></summary><div class="neu-filters__group-body">' + rows + '</div></details>'; }

  var singleCat = null, singleCondFam = null;
  function famOf(code) { code = lc(code); if (code.indexOf('sd') === 0) return 'scratch'; if (code === 'ob') return 'open'; if (code === 'cr') return 'refurb'; if (code === 'new') return 'new'; return null; }
  function famCodes(fam) { return fam === 'open' ? ['ob'] : fam === 'refurb' ? ['cr'] : fam === 'new' ? ['new'] : fam === 'scratch' ? ['sdmin', 'sdmod', 'sdmaj'] : []; }
  // Adapt the rail to the collection with no per-collection config:
  //   single category  -> category page: hide the Category parent, show that category's sub-filters directly
  //   single condition -> condition page: hide the Condition group (redundant here)
  function detectContext() {
    // Category: from the scoped products (robust — category isn't double-tagged).
    var catC = {}, nCat = 0;
    ITEMS.forEach(function (p) { var cs = p.f.category || []; if (cs.length) { nCat++; cs.forEach(function (c) { catC[c] = (catC[c] || 0) + 1; }); } });
    var cats = Object.keys(catC); if (cats.length) { cats.sort(function (a, b) { return catC[b] - catC[a]; }); if (cats.length === 1 || catC[cats[0]] / nCat >= 0.9) singleCat = cats[0]; }
    // Condition family: from the collection HANDLE (deterministic — products are often double-tagged
    // with a stray S&D code, which fooled product-based detection). Falls back to products if unambiguous.
    var h = (COLLECTION_URL.split('/').pop() || '').toLowerCase();
    if (/open-?box/.test(h)) singleCondFam = 'open';
    else if (/refurb/.test(h)) singleCondFam = 'refurb';
    else if (/scratch|dent/.test(h)) singleCondFam = 'scratch';
    else if (/new-appliance|new-in-box/.test(h)) singleCondFam = 'new';
    if (!singleCondFam) {
      var famC = {}; ITEMS.forEach(function (p) { var fams = {}; (p.f.condition || []).forEach(function (c) { var fm = famOf(c); if (fm) fams[fm] = 1; }); Object.keys(fams).forEach(function (fm) { famC[fm] = (famC[fm] || 0) + 1; }); });
      var fams = Object.keys(famC); if (fams.length === 1) singleCondFam = fams[0];
    }
  }

  function buildRail() {
    var G = TAX.globals, L = TAX.dimLabels, CATS = TAX.categories;
    var html = '<div class="neu-filters__bar"><span class="neu-filters__heading">Filter</span><button type="button" class="neu-filters__clear" data-lab-clear>Clear all</button></div>';
    if (!singleCondFam) html += group(L.condition || 'Condition', G.condition.map(function (o) { return opt('condition', o[0], o[1], countFor('condition', o[0])); }).join(''), true);
    if (!singleCat) html += group(L.category || 'Category', G.category.map(function (o) { return opt('category', o[0], o[1], countFor('category', o[0])); }).join(''), true);
    var catsToShow = singleCat ? [singleCat] : Object.keys(CATS);
    catsToShow.forEach(function (cat) {
      var dims = CATS[cat]; if (!dims) return;
      Object.keys(dims).forEach(function (dimKey) {
        var rows = dims[dimKey].map(function (o) { return opt(dimKey, o[0], o[1], countFor(dimKey, o[0])); }).join('');
        // data-sub marks sub-dim groups for filtering; data-pcat (only in multi-category mode) drives the cascade
        var attrs = ' data-sub="1"' + (singleCat ? '' : ' data-pcat="' + esc(cat) + '"');
        html += group(L[dimKey] || dimKey, rows, true, attrs);
      });
    });
    var vc = vendorCounts();
    html += group('Manufacturer', Object.keys(vc).sort().map(function (v) { return opt('vendor', v, v, vc[v]); }).join(''));
    html += group(L.color || 'Color', G.color.map(function (o) { return opt('color', o[0], o[1], countFor('color', o[0])); }).join(''));
    html += group(L.location || 'Location', G.location.map(function (o) { return opt('location', o[0], o[1], countFor('location', o[0])); }).join(''));
    html += '<details class="neu-filters__group"><summary class="neu-filters__group-title">Price<span class="neu-filters__plus"></span></summary><div class="neu-filters__group-body"><div class="neu-filters__price"><label>Min <input type="number" inputmode="decimal" id="labMin" min="0" placeholder="0"></label><label>Max <input type="number" inputmode="decimal" id="labMax" min="0" placeholder="max"></label></div></div></details>';
    html += '<button type="button" class="btn btn--gold btn--full neu-filters__apply" data-lab-clear>Reset filters</button>';
    filterRoot.innerHTML = html;
    updateVisibility();
    // task 86e21qxp6: applying a filter re-renders the grid and may reveal/hide sub-filter groups, which
    // made the page jump. Preserve the scroll position across the update so the viewport stays put.
    var keepScroll = function (fn) { var y = window.pageYOffset; fn(); window.scrollTo(0, y); };
    filterRoot.addEventListener('change', function (e) { if (e.target.matches('input[type="checkbox"]')) keepScroll(function () { updateVisibility(); apply(); }); });
    filterRoot.addEventListener('input', function (e) { if (e.target.id === 'labMin' || e.target.id === 'labMax') keepScroll(apply); });
    filterRoot.addEventListener('click', function (e) { if (e.target.closest('[data-lab-clear]')) clearAll(e); });
  }
  function updateVisibility() {
    var selCats = selected('category');
    [].slice.call(filterRoot.querySelectorAll('details.neu-filters__group[data-pcat]')).forEach(function (g) {
      var visible = selCats.indexOf(g.getAttribute('data-pcat')) > -1;
      g.style.display = visible ? '' : 'none';
      if (!visible) [].slice.call(g.querySelectorAll('input:checked')).forEach(function (i) { i.checked = false; });
    });
  }
  function activeSubDimSelections() {
    var sel = {};
    [].slice.call(filterRoot.querySelectorAll('details.neu-filters__group[data-sub]')).forEach(function (g) {
      if (g.style.display === 'none') return;
      [].slice.call(g.querySelectorAll('input[data-fgroup]:checked')).forEach(function (i) { var k = i.getAttribute('data-fgroup'); (sel[k] = sel[k] || []).push(lc(i.value)); });
    });
    return sel;
  }
  function hasAny(itemVals, wanted) { if (!itemVals) return false; for (var i = 0; i < itemVals.length; i++) if (wanted.indexOf(lc(itemVals[i])) > -1) return true; return false; }

  // Filter state in the URL: fixes back-nav (browser restores the filtered view) + makes filtered pages shareable.
  var URL_KEEP = ['preview_theme_id', 'filter.v.availability', '_fd', '_ab', '_sc', 'pb', 'q', 'type'];
  function syncUrl() {
    var params = new URLSearchParams();
    var groups = {};
    [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]:checked')).forEach(function (i) { var g = i.getAttribute('data-fgroup'); (groups[g] = groups[g] || []).push(i.value); });
    Object.keys(groups).forEach(function (g) { params.set(g, groups[g].join(',')); });
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    if (minI && minI.value) params.set('min', minI.value);
    if (maxI && maxI.value) params.set('max', maxI.value);
    var cur = new URLSearchParams(location.search);
    URL_KEEP.forEach(function (k) { if (cur.has(k)) params.set(k, cur.get(k)); });
    var qs = params.toString();
    try { history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
  }
  function restoreFromUrl() {
    var params = new URLSearchParams(location.search);
    [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]')).forEach(function (i) {
      var g = i.getAttribute('data-fgroup');
      if (params.has(g) && params.get(g).split(',').indexOf(i.value) > -1) i.checked = true;
    });
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    if (minI && params.has('min')) minI.value = params.get('min');
    if (maxI && params.has('max')) maxI.value = params.get('max');
  }

  function subDimKeys() { var s = {}; [].slice.call(filterRoot.querySelectorAll('details.neu-filters__group[data-sub] input[data-fgroup]')).forEach(function (i) { s[i.getAttribute('data-fgroup')] = 1; }); return Object.keys(s); }
  function currentSel() {
    var sel = {};
    ['condition', 'category', 'color', 'location'].forEach(function (g) { var v = selected(g).map(lc); if (v.length) sel[g] = v; });
    var ven = selected('vendor'); if (ven.length) sel.vendor = ven;
    var sub = activeSubDimSelections(); for (var k in sub) sel[k] = sub[k];
    return sel;
  }
  function matchesSel(p, sel, except, lo, hi) {
    if (except !== 'price' && (p.price < lo || p.price > hi)) return false;
    for (var d in sel) { if (d === except) continue; if (d === 'vendor') { if (sel[d].indexOf(p.vendor) < 0) return false; } else if (!hasAny(p.f[d], sel[d])) return false; }
    return true;
  }
  // Disjunctive facet counts: each option shows how many products it would yield given the OTHER active
  // filters, so counts recalc as you select (like Kidsy). Zero-yield options are greyed + disabled — this
  // also removes the "count says 2 but 0 results" mismatch, because the count is now the real result count.
  function updateCounts() {
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    var lo = parseFloat(minI && minI.value) || 0, hi = parseFloat(maxI && maxI.value) || Infinity;
    var sel = currentSel();
    var dims = ['condition', 'category', 'color', 'location', 'vendor'].concat(subDimKeys());
    var counts = {}; dims.forEach(function (d) { counts[d] = {}; });
    ITEMS.forEach(function (p) {
      dims.forEach(function (d) {
        if (!matchesSel(p, sel, d, lo, hi)) return;
        var vals = d === 'vendor' ? (p.vendor ? [p.vendor] : []) : (p.f[d] || []);
        vals.forEach(function (v) { var key = d === 'vendor' ? v : lc(v); counts[d][key] = (counts[d][key] || 0) + 1; });
      });
    });
    [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]')).forEach(function (i) {
      var d = i.getAttribute('data-fgroup'), key = d === 'vendor' ? i.value : lc(i.value);
      var n = (counts[d] && counts[d][key]) || 0;
      var lab = i.closest('.neu-filters__opt'); if (!lab) return;
      var span = lab.querySelector('.neu-filters__opt-count'); if (span) span.textContent = n;
      var dead = n === 0 && !i.checked;
      i.disabled = dead; lab.classList.toggle('neu-filters__opt--empty', dead);
    });
  }
  function apply() {
    var fCond = selected('condition').map(lc), fCat = selected('category').map(lc), fCol = selected('color').map(lc), fLoc = selected('location').map(lc), fVen = selected('vendor');
    var sub = activeSubDimSelections();
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    var lo = parseFloat(minI && minI.value) || 0, hi = parseFloat(maxI && maxI.value) || Infinity;
    filtered = ITEMS.filter(function (p) {
      if (fCond.length && !hasAny(p.f.condition, fCond)) return false;
      if (fCat.length && !hasAny(p.f.category, fCat)) return false;
      if (fCol.length && !hasAny(p.f.color, fCol)) return false;
      if (fLoc.length && !hasAny(p.f.location, fLoc)) return false;
      if (fVen.length && fVen.indexOf(p.vendor) < 0) return false;
      for (var k in sub) { if (sub[k].length && !hasAny(p.f[k], sub[k])) return false; }
      if (p.price < lo || p.price > hi) return false;
      return true;
    });
    sortFiltered(); shown = PAGE; render(); syncUrl(); updateCounts();
  }
  // "Outlet Appliances" default sort (clients 86e1zc7xe + 86e27z1mb):
  //  1) CONDITION first: Scratch & Dent -> Open Box -> Certified Refurb -> New in Box (last).
  //  2) WITHIN each condition: a RANDOM mix of the desirable products up top (shuffle key item.rnd, baked
  //     per index build so it's stable per rebuild ~20 min), then Discount_LIQ items, then the low-value
  //     small-appliance styles + untagged leftovers at the bottom of that condition's block.
  // "High value" here means desirable-by-style, NOT price — the client rejected a price sort (looked too high-end).
  var LOVAL_ALWAYS = { mini: 1, wine: 1, allref: 1, bev: 1 };   // REF mini / wine / all-fridge / beverage: always low-value
  var LOVAL_CHEAPFRZ = { chest: 1, stuf: 1 };                    // chest / standup freezers: only when under $500
  function isLowValue(p) {
    var st = (p.f && p.f.style) || [];
    for (var i = 0; i < st.length; i++) {
      var s = lc(st[i]);
      if (LOVAL_ALWAYS[s]) return true;
      if (LOVAL_CHEAPFRZ[s] && (p.price || 0) < 500) return true;
    }
    return false;
  }
  function condTier(p) { var c = lc(p.cond || ''); if (c === 'open') return 1; if (c === 'refurb') return 2; if (c === 'new') return 3; return 0; } // scratch + untagged -> first
  function subTier(p) {
    var c = lc(p.cond || '');
    var known = (c === 'scratch' || c === 'open' || c === 'refurb' || c === 'new');
    if (p.liq) return 1;                       // Discount_LIQ -> middle of the block
    if (isLowValue(p) || !known) return 2;     // low-value styles + untagged/leftover -> bottom of the block
    return 0;                                  // desirable products -> random top of the block
  }
  function sortFiltered() {
    var s = sortSel.value;
    filtered.sort(function (a, b) {
      if (s === 'price-asc') return a.price - b.price || a.prio - b.prio;
      if (s === 'price-desc') return b.price - a.price || a.prio - b.prio;
      if (s === 'title') return a.title.localeCompare(b.title);
      if (s === 'recent') return (b.added || 0) - (a.added || 0) || a.prio - b.prio; // newest first (task 86e26y4c9)
      // default "Outlet Appliances": condition (S&D -> Open Box -> Refurb -> New) then within each block: random mix -> LIQ -> low-value/leftover.
      return condTier(a) - condTier(b) || subTier(a) - subTier(b) || (a.rnd || 0) - (b.rnd || 0) || a.price - b.price;
    });
  }
  function render() {
    // Badge follows the active condition filter; on a condition page (no filter, Condition hidden)
    // it follows the page's condition so an Open Box page shows "Open Box", not the default S&D pick.
    var condSel = selected('condition').map(lc);
    if (!condSel.length && singleCondFam) condSel = famCodes(singleCondFam);
    var slice = filtered.slice(0, shown);
    grid.innerHTML = slice.map(function (p) { return cardHTML(p, condSel); }).join('');
    if (window.neuFillStars) window.neuFillStars(grid);   // fill card stars (rendered after the initial pass)
    countEl.innerHTML = 'Showing <b>' + slice.length + '</b> of <b>' + filtered.length + '</b> products';
    emptyEl.hidden = filtered.length > 0;
    moreBtn.hidden = shown >= filtered.length;
  }
  function clearAll(e) {
    if (e) e.preventDefault();
    filterRoot.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    if (minI) minI.value = ''; if (maxI) maxI.value = '';
    updateVisibility(); apply();
  }
  sortSel.addEventListener('change', function () { sortFiltered(); shown = PAGE; render(); });
  moreBtn.addEventListener('click', function () { shown += PAGE; render(); });
  emptyEl.addEventListener('click', function (e) { if (e.target.closest('[data-lab-clear]')) clearAll(e); });
  var toggle = root.querySelector('[data-lab-toggle]'), fwrap = root.querySelector('.shop__filters');
  if (toggle && fwrap) toggle.addEventListener('click', function () { fwrap.classList.toggle('is-open'); });
  var view = root.querySelector('.shop__view');
  if (view) view.addEventListener('click', function (e) { var b = e.target.closest('.shop__view-btn'); if (!b) return; view.querySelectorAll('.shop__view-btn').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); grid.classList.toggle('is-list', b.getAttribute('data-view') === 'list'); });
})();
